import { AbstractControl } from '@angular/forms';

export class CustomFormValidator {
    message(cntl: AbstractControl): string {
        let errorText = '';
        if ((!cntl.valid && (cntl.touched || cntl.dirty))) {
            const errorName = Object.keys(cntl.errors)[0]; // first error only
            const errorValue = cntl.errors[errorName];

        switch (errorName) {
            case 'required': errorText = 'Required'; break;
            case 'maxlength': errorText = `Maximum length is ${errorValue.requiredLength}`; break;
            case 'minlength': errorText = `Minimum length is ${errorValue.requiredLength}`; break;
            case 'pattern': errorText = 'Invalid format'; break;
            case 'sameAs': errorText = 'Mismtach'; break;
            case 'notSameAs' : errorText = 'Same value selected'; break;
            case 'passwordComplexity' : errorText = 'Insecure or Invalid Password'; break;
            case 'mustNotContain' : errorText = 'Must not contain personal details'; break;
            case 'depends': errorText = 'Required'; break;
            case 'invalidPhone': errorText = 'Invalid Phone'; break;
            case 'invalidZip': errorText = 'Invalid ZIP Code'; break;
            case 'invalidEmail': errorText = 'Invalid Email'; break;
            default: errorText = 'Invalid';
          }
        }

        return errorText;
    }

    depends: any = (key: string, value?: string) => {
        return (cntl: AbstractControl) => {
            if (cntl.dirty) {
                if (!cntl.value && ((!value && cntl.parent.controls[key].value) || (cntl.parent.controls[key].value === value))) {
                    return { depends: true };
                }
            }

            return null;
        };
    }

    sameAs: any = (key: string) => {
        return (cntl: AbstractControl) => {
            if (cntl.dirty) {
                if (cntl.value !== cntl.parent.controls[key].value) {
                    return { sameAs: true };
                }
            }
            return null;
        };
    }

    notSameAs: any = (key: string) => {
        return (cntl: AbstractControl) => {
            if (cntl.dirty) {
                if ((cntl.value && cntl.parent.controls[key].value) && cntl.value === cntl.parent.controls[key].value) {
                    return { notSameAs: true };
                }
            }

            return null;
        };
    }

    mustNotContain: any = (key: string) => {
        return (cntl: AbstractControl) => {
            if (cntl.dirty) {
                if ((cntl.value && cntl.parent.controls[key].value) && (cntl.value.toLowerCase().indexOf(cntl.parent.controls[key].value.toLowerCase()) !== -1)) {
                    return { mustNotContain: true };
                }
            }

            return null;
        };
    }

    passwordComplexity (cntl: AbstractControl): any {
        if (cntl.dirty && cntl.value) {
            if ((cntl.value.search(/(.*\d){1}/) === -1) || (cntl.value.search(/(.*[a-z]){1}/) === -1) || (cntl.value.search(/(.*[A-Z]){1}/) === -1) || (cntl.value.search(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) === -1) || (cntl.value.indexOf('&') !== -1) || (cntl.value.indexOf(' ') !== -1)) {
                return { passwordComplexity: true };
            }
        }

        return null;
    }
}
